import React, { useCallback, useState } from 'react';
import TrainingContent from './TrainingContent';
import TrainingHeader from './TrainingHeader';

import { SpecificTrainingProps } from './Types';
import { themeColor } from '../../../services/styleUtils/colorUtils';
import { useTheme } from '@emotion/react';
import { getContentStyle } from '../../../services/styleUtils/contentStyleUtils';

const SpecificTrainingMain = ({
  backgroundStyle,
  title,
  titleStyle,
  subTitle,
  subTitleStyle,
  numberOfDays,
  numberOfDaysStyle,
  includedButtonLabel,
  includedButtonStyle,
  contentTitle,
  contentTitleStyle,
  options,
  expandOnLanding,
  iconColor,
  shortTextColor,
  desktopAlignment,
  mobileAlignment,
  contactUsButton,
  contactUsButtonStyle,
  contentBackgroundColor,
}: SpecificTrainingProps) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState<boolean>(
    typeof expandOnLanding === 'string' &&
      expandOnLanding.toLowerCase() === 'true',
  );

  const handleToggle = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  const iconColorToUse = iconColor?.color
    ? themeColor(theme, iconColor?.color)
    : '#fff';

  const shortTextColorToUse = shortTextColor?.color
    ? themeColor(theme, shortTextColor?.color)
    : '#fff';

  const subTitleStyleToUse = subTitleStyle
    ? getContentStyle(theme, subTitleStyle)
    : {};
  let numberOfDaysStyleToUse = {};
  if (numberOfDaysStyle) {
    const { textColor, alignment, fontSize, lineHeight, ...rest } =
      getContentStyle(theme, numberOfDaysStyle);
    numberOfDaysStyleToUse = {
      color: textColor,
      textAlign: alignment,
      fontSize,
      lineHeight,
      ...rest,
    };
    Object.keys(numberOfDaysStyleToUse).forEach(
      (key) =>
        numberOfDaysStyleToUse[key] === undefined &&
        delete numberOfDaysStyleToUse[key],
    );
  }

  const backgroundColor = backgroundStyle?.color
    ? themeColor(theme, backgroundStyle?.color)
    : null;

  const contentBackgroundColorToUse = contentBackgroundColor?.color
    ? themeColor(theme, contentBackgroundColor?.color)
    : null;

  return (
    <section className="mt-[30px]">
      <div className="w-full max-w-[385px] md:w-auto lg:max-w-[1332px] mx-auto relative overflow-visible">
        <TrainingHeader
          backgroundStyle={{
            ...backgroundStyle,
            color: backgroundColor as string,
          }}
          title={title}
          titleStyle={titleStyle}
          subTitle={subTitle}
          subTitleStyle={{
            ...subTitleStyleToUse,
          }}
          numberOfDays={numberOfDays}
          numberOfDaysStyle={{
            ...numberOfDaysStyleToUse,
          }}
          includedButtonLabel={includedButtonLabel || "What's Included"}
          includedButtonStyle={includedButtonStyle}
          expanded={expanded}
          onToggle={handleToggle}
        />
        {expanded && (
          <TrainingContent
            contentTitle={contentTitle}
            contentTitleStyle={contentTitleStyle}
            options={options}
            iconColor={iconColorToUse}
            shortTextColor={shortTextColorToUse}
            desktopAlignment={desktopAlignment}
            mobileAlignment={mobileAlignment}
            contactUsButton={contactUsButton}
            contactUsButtonStyle={contactUsButtonStyle}
            contentBackgroundColor={contentBackgroundColorToUse}
          />
        )}
      </div>
    </section>
  );
};

export default SpecificTrainingMain;
